"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditTask = void 0;
var _Modal = require("../../../Layout/Modal");
var _react = require("react");
var _TaskManager = require("../TaskManager.provider");
var _Button = require("../../../UI/Button");
var _EditTaskGuidelines = require("./partials/EditTaskGuidelines");
var _EditTaskName = require("./partials/EditTaskName");
var _TaskManager2 = _interopRequireDefault(require("../TaskManager.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditTask = props => {
  const {
    isLearningActivity
  } = props;
  const {
    getLabel,
    setIsEditTaskDataOpened,
    isEditTaskDataChanged,
    editTaskDataName = '',
    editTaskDataGuideLines = '',
    task,
    setTask,
    setIsChanged
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const styles = (0, _TaskManager2.default)();
  const handleBack = () => {
    setIsEditTaskDataOpened(false);
  };
  const handleSave = () => {
    if (!task?.isReadOnly && isEditTaskDataChanged && /\S/.test(editTaskDataName) && (/\S/.test(editTaskDataGuideLines) || isLearningActivity)) {
      setTask({
        ...task,
        name: editTaskDataName,
        guideLines: editTaskDataGuideLines
      });
      setIsEditTaskDataOpened(false);
      setIsChanged(true);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-TaskManager__full-item'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
      title: getLabel('edit_task_title')
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Content, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_EditTaskName.EditTaskName, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditTaskGuidelines.EditTaskGuidelines, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Footer, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "link",
          onClick: handleBack,
          children: getLabel('back')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "contained",
          color: "primary",
          onClick: handleSave,
          isDisabled: !(isEditTaskDataChanged && /\S/.test(editTaskDataName) && (/\S/.test(editTaskDataGuideLines) || isLearningActivity)),
          children: getLabel('save')
        })
      })]
    })]
  });
};
exports.EditTask = EditTask;